import ArmeriaApiRepository from '@/modules/armeria/infrastructure/ArmeriaApiRepository'

const repository = new ArmeriaApiRepository()

export default {
  namespaced: true,

  state: {
    auditorias: [],
    auditoria: null,
    personalArmas: [],
    removeResult: null,
    historial: [],
  },

  getters: {
    getAuditorias: (state) => state.auditorias,
    getAuditoria: (state) => state.auditoria,
    getPersonalArmas: (state) => {
      const seen = new Set()
      return state.personalArmas.filter((p) => {
        if (!p.CUIP) return true
        if (seen.has(p.CUIP)) return false
        seen.add(p.CUIP)
        return true
      })
    },
    getRemoveResult: (state) => state.removeResult,
    getHistorial: (state) => state.historial,
  },

  mutations: {
    SET_AUDITORIAS(state, auditorias) {
      state.auditorias = auditorias
    },
    SET_AUDITORIA(state, auditoria) {
      state.auditoria = auditoria
    },
    SET_PERSONAL_ARMAS(state, personalArmas) {
      state.personalArmas = personalArmas
    },
    SET_REMOVE_RESULT(state, result) {
      state.removeResult = result
    },
    SET_HISTORIAL(state, historial) {
      state.historial = historial
    },
  },

  actions: {
    async fetchAuditorias({ commit }) {
      try {
        const data = await repository.findAll()
        commit('SET_AUDITORIAS', data)
      } catch (error) {
        console.log(error)
      }
    },

    async fetchAuditoriaById({ commit }, idAuditoria) {
      try {
        const data = await repository.findById(idAuditoria)
        commit('SET_AUDITORIA', data)
      } catch (error) {
        console.log(error)
      }
    },

    async fetchHistorialByArma({ commit }, idArma) {
      try {
        const data = await repository.findHistorialByArma(idArma)
        commit('SET_HISTORIAL', data)
      } catch (error) {
        console.log(error)
      }
    },

    async createAuditoria({ dispatch }, payload) {
      try {
        await repository.create(payload)
        dispatch('fetchAuditorias')
      } catch (error) {
        console.log(error)
      }
    },

    async fetchPersonalArmas({ commit }) {
      try {
        const data = await repository.getPersonalArmas()
        commit('SET_PERSONAL_ARMAS', data)
      } catch (error) {
        console.log(error)
      }
    },

    async removePersonalLoc({ commit }, { idPersonal, idPersonalLoc }) {
      try {
        await repository.removePersonalLoc(idPersonal, idPersonalLoc)
      } catch (error) {
        console.log(error)
      }
    },
  },
}
